
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 47 47","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M23.5 1C11.073 1 1 11.074 1 23.498 1 35.926 11.073 46 23.5 46S46 35.926 46 23.498C46 11.074 35.927 1 23.5 1z","fill":"#4FA2B7"}}),_c('path',{attrs:{"d":"M20.84 22l-4.92 4.92-1.42-1.42L17 23h-5v-2h5l-2.5-2.5 1.42-1.42L20.84 22M24 13c-3.41 0-6.32 1.07-7.47 2.57L17 16l1.03 1.07C18 17.05 18 17 18 17c0-.5 2.13-2 6-2s6 1.5 6 2-2.13 2-6 2c-2.62 0-4.42-.69-5.32-1.28l3.12 3.12c.7.1 1.44.16 2.2.16 2.39 0 4.53-.53 6-1.36v2.81c-1.3.95-3.58 1.55-6 1.55-.96 0-1.9-.1-2.76-.27l-1.65 1.64c1.32.4 2.82.63 4.41.63 2.28 0 4.39-.45 6-1.23V27c0 .5-2.13 2-6 2s-6-1.5-6-2v-.04L17 28l-.46.43C17.69 29.93 20.6 31 24 31c4.41 0 8-1.79 8-4V17c0-2.21-3.58-4-8-4z","fill":"#FFF","fill-rule":"nonzero"}})])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/tools_svgs/externalImportFill.svg